import Footer from "../components/footer";
import React, { useState, useRef } from "react";
import Swal from "sweetalert2";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { FaEnvelope, FaMapMarkerAlt, FaPaperPlane, FaUser, FaMapMarkedAlt, FaCrosshairs } from "react-icons/fa"; // Necesitarás instalar react-icons
import ReCAPTCHA from "react-google-recaptcha";
import { API_URL } from "../App.js";

// Configuración del icono del mapa
let iconDefault = L.icon({
  iconUrl: icon,
  iconShadow: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const markerPosition = [4.0741833768975635, -73.5839960003354];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    message: "",
  });

  const { name, surname, email, message } = formData;
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);
  const mapRef = useRef(null);

  // Función para centrar el mapa
  const handleCenterMap = () => {
    if (mapRef.current) {
      mapRef.current.setView(markerPosition, 15);
    }
  };

  // Función para abrir en Google Maps
  const handleOpenInGoogleMaps = () => {
    const [lat, lng] = markerPosition;
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      const isValidEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
      setIsEmailValid(isValidEmail || value === "");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEmailValid || !email) {
      Swal.fire({
        icon: "error",
        title: "Correo inválido",
        text: "Por favor verifica tu correo electrónico.",
      });
      return;
    }

    // Validar reCAPTCHA
    if (!captchaToken) {
      Swal.fire({
        icon: "warning",
        title: "Verificación requerida",
        text: "Por favor completa la verificación reCAPTCHA.",
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(API_URL + "contacts/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: `${name} ${surname}`,
          email,
          asunto: "Contacto desde la web",
          message,
          recaptchaToken: captchaToken,
        }),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "¡Enviado!",
          text: "Gracias por contactarnos, te responderemos pronto.",
          confirmButtonColor: "#1a365d",
        });
        setFormData({ name: "", surname: "", email: "", message: "" });
        setCaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al enviar");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Hubo un problema de conexión. Inténtalo más tarde.",
      });
      // Reset captcha en caso de error
      setCaptchaToken(null);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  return (
    <div className="flex flex-col flex-grow bg-gray-100">
      {/* Contenedor Principal Centrado */}
      <div className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl w-full bg-white shadow-2xl rounded-3xl overflow-hidden flex flex-col lg:flex-row">

          {/* LADO IZQUIERDO: Formulario */}
          <div className="w-full lg:w-[55%] p-8 md:p-12">
            <div className="text-left mb-5">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 font-sans mb-4">
                Déjanos tus datos
              </h2>
              <hr className="border-t border-gray-300 opacity-50" />
            </div>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Input Nombre */}
                <div className="relative">
                  <label className="text-xs font-bold text-black-500 tracking-wide uppercase mb-2 block">Nombre</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                      <FaUser />
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all duration-300 font-sans text-sm"
                      placeholder="Tu nombre"
                    />
                  </div>
                </div>

                {/* Input Apellido */}
                <div className="relative">
                  <label className="text-xs font-bold text-black-500 tracking-wide uppercase mb-2 block">Apellido</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                      <FaUser />
                    </div>
                    <input
                      type="text"
                      name="surname"
                      value={surname}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all duration-300 font-sans text-sm"
                      placeholder="Tu apellido"
                    />
                  </div>
                </div>
              </div>

              {/* Input Email */}
              <div className="relative">
                <label className="text-xs font-bold text-black-500 tracking-wide uppercase mb-2 block">Correo Electrónico</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                    <FaEnvelope />
                  </div>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    required
                    className={`w-full pl-10 pr-4 py-3 rounded-lg bg-gray-50 border text-gray-800 outline-none transition-all duration-300 font-sans text-sm ${!isEmailValid
                      ? "border-red-500 focus:ring-red-200"
                      : "border-gray-200 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                      }`}
                    placeholder="ejemplo@correo.com"
                  />
                </div>
                {!isEmailValid && (
                  <span className="text-red-500 text-xs mt-1 block">Ingresa un correo válido</span>
                )}
              </div>

              {/* Input Mensaje */}
              <div className="relative">
                <label className="text-xs font-bold text-black-500 tracking-wide uppercase mb-2 block">Mensaje</label>
                <textarea
                  name="message"
                  value={message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full p-4 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all duration-300 resize-none font-sans text-sm"
                  placeholder="Escribe aquí tu mensaje..."
                ></textarea>
              </div>

              {/* reCAPTCHA */}
              <div className="flex justify-center">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
                  onChange={handleCaptchaChange}
                  onExpired={() => setCaptchaToken(null)}
                />
              </div>

              {/* Botón */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full flex items-center justify-center space-x-2 py-2 px-8 rounded-lg bg-[#1a365d] hover:bg-[#152c4e] text-white font-bold transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none"
              >
                <span>{isSubmitting ? "Enviando..." : "Enviar Mensaje"}</span>
                {!isSubmitting && <FaPaperPlane className="text-sm" />}
              </button>
            </form>
          </div>

          {/* LADO DERECHO: Información y Mapa */}
          <div className="w-full lg:w-[45%] bg-[#1a365d] text-white p-8 md:p-10 flex flex-col justify-between relative overflow-hidden">
            {/* Decoración de fondo */}
            <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 rounded-full bg-white opacity-10 blur-2xl"></div>
            <div className="absolute bottom-0 left-0 -ml-10 -mb-10 w-40 h-40 rounded-full bg-white opacity-10 blur-2xl"></div>

            <div className="relative z-10 mb-2">
              <h3 className="text-xl font-bold mb-4 font-sans text-left">Información de Contacto</h3>

              <div className="space-y-4">
                <div className="flex items-start space-x-4 group">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white/20 transition-colors">
                    <FaEnvelope className="text-white" />
                  </div>
                  <div>
                    <p className="text-xs text-blue-200 uppercase font-bold tracking-wider mb-1 text-left">Correo</p>
                    <a href="mailto:adalab@unillanos.edu.co" className="text-white hover:text-blue-200 transition-colors font-sans block break-all">
                      adalab@unillanos.edu.co
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4 group">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white/20 transition-colors">
                    <FaMapMarkerAlt className="text-white" />
                  </div>
                  <div>
                    <p className="text-xs text-blue-200 uppercase font-bold tracking-wider mb-1 text-left">Ubicación</p>
                    <p className="text-white font-sans text-sm leading-relaxed text-left">
                      Universidad de los Llanos Campus Barcelona Km. 12 Vía Puerto López 3 piso Edificio Albert Einstein - Salón 312A
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Mapa Integrado */}
            <div className="relative z-10 h-100 w-full rounded-xl overflow-hidden shadow-lg border-2 border-white/20">
              <MapContainer
                center={markerPosition}
                zoom={15}
                scrollWheelZoom={true}
                className="h-full w-full"
                ref={mapRef}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; OpenStreetMap'
                />
                <Marker position={markerPosition} icon={iconDefault}>
                  <Popup className="font-sans text-gray-800">
                    <strong>AdaLab</strong><br />3 piso Edificio Albert Einstein - Salón 312A.
                  </Popup>
                </Marker>
              </MapContainer>
              
              {/* Botones del mapa */}
              <div className="absolute bottom-4 right-4 flex flex-col gap-2 z-[1000]">
                {/* Botón para centrar el mapa */}
                <button
                  onClick={handleCenterMap}
                  className="bg-white hover:bg-gray-100 text-gray-800 p-3 rounded-lg shadow-lg transition-all duration-200 hover:shadow-xl group"
                  title="Centrar mapa"
                >
                  <FaCrosshairs className="text-lg group-hover:text-blue-600" />
                </button>
                
                {/* Botón para abrir en Google Maps */}
                <button
                  onClick={handleOpenInGoogleMaps}
                  className="bg-white hover:bg-gray-100 text-gray-800 p-3 rounded-lg shadow-lg transition-all duration-200 hover:shadow-xl group"
                  title="Ver en Google Maps"
                >
                  <FaMapMarkedAlt className="text-lg group-hover:text-blue-600" />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;